(function TripSummaryCruiseDays($, Adzuki)
{
	'use strict';

	const component = {
		inject: [
			'getFaIconStyle',
		],
		props: {
			currentDays: {
				type    : Array,
				default : [],
				required: false,
			},
			formId: {
				type    : String,
				required: true,
			},
			formName: {
				type    : String,
				required: true,
			},
		},
		template: '#ts-cruise-days',
		data() {
			return {
				baseUri           : Adzuki.base_uri,
				cruiseDays        : this.currentDays,
				selectedDay       : null,
				showReplaceModal  : false,
				showPlayVideoModal: false,
				playVideoHtml     : '',
				currentVideo      : null,
			};
		},
		watch: {
			currentDays(newVal) {
				this.cruiseDays = newVal;

				this.$nextTick(() => {
					const textAreas = document.querySelectorAll('.cruise-day-text');

					// initialize the editor for each cruise day text area
					for (const textArea of textAreas) {
						const content   = textArea.value;
						const id        = textArea.id;
						const uploadUrl = Adzuki.get_url('/Main/uploadImage');
						const options   = {
							height                : 200,
							editor_type           : 'web',
							images_upload_url     : uploadUrl,
							init_instance_callback: function _initEditor(editor) {
								editor.setContent(content);
								textArea.value = content;
							},
						};

						Adzuki.Editor('#' + id, options);
					}
				});
			},
		},
		methods: {
			closePlayVideoModal() {
				this.showPlayVideoModal = false;
				this.currentVideo       = null;
				this.playVideoHtml      = '';
			},
			closeReplaceModal() {
				this.showReplaceModal = false;
			},
			formatDate(date) {
				return moment(date).format('dddd, MMMM D, YYYY');
			},
			getCruiseDayTitle(cruiseDay) {
				let title = cruiseDay.city;

				if (parseInt(cruiseDay.cruise_tour)) {
					title += ' (Land)';
				}

				if (cruiseDay.date) {
					title += ' on ' + this.formatDate(cruiseDay.date);
				}

				return title;
			},
			async initAddImageFromLibraryForm(cruiseDay, modal) {
				const modalEl = $('#modalWindow');

				try {
					const html = await Adzuki.Ajax.get('/TripSummaryPictureLibrary/addCruiseDayImageFromLibrary');

					modalEl.find('.modal-body #library-picture').html(html);

					// initialize the image library search form
					Adzuki.Form.initAjaxForm('ImageLibrarySearch');

					// handle selecting images from the image library
					modalEl.find('.ts-add-selected-pictures').first().off().on('click', (e) => {
						e.preventDefault();

						const selectedImages = modalEl.find('.item-checkboxes:checked');
						const imageIds       = [];

						if (selectedImages.length === 0) {
							Adzuki.StatusMessage('error', 'No images selected');
							return;
						}

						if (selectedImages.length > 1) {
							Adzuki.StatusMessage('error', 'Only one image can be added to a cruise day');
							return;
						}

						selectedImages.each((i, img) => {
							const id = parseInt($(img).val());

							imageIds.push(id);
						});

						this.setCruiseDayImageFromLibrary(cruiseDay, imageIds[0]);

						modal.hide();
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error initializing add images from library form: ${error.message}`);
				}
			},
			async initUploadImageForm(cruiseDay, modal) {
				const modalEl = $('#modalWindow');

				// register the form
				const form = {
					name: 'CruiseDayImage',
				};

				form.load = function load() {
					_initDragDropUpload();
					_initLocationSearch();
				};

				form.success = (response) => {
					if (Adzuki.Form.hasError(response)) {
						return false;
					}

					const image = response.data.image;

					// update the image in the cruise day
					cruiseDay.image = image;

					modal.hide();
				};

				Adzuki.Form.registerForm(form);

				try {
					const html = await Adzuki.Ajax.get('/TripSummaryPictureLibrary/addCruiseDayImage');

					modalEl.find('.modal-body #load-new-picture').html(html);

					// initialize the form, which will trigger the success callback above on submission
					Adzuki.Form.initAjaxForm('CruiseDayImage');
				} catch (e) {
					Adzuki.StatusMessage('error', `Error loading image library: ${e.message}`);
				}
			},
			playVideo(videoUrl) {
				this.showPlayVideoModal = true;
				this.currentVideo       = videoUrl;
				const videoSrc          = this.baseUri + '/' + videoUrl;

				this.playVideoHtml = '<div class="text-center"><video controls width="840" height="480" playsinline autoplay muted><source src="' + videoSrc + '" type="video/mp4">Your browser does not support the video tag.</video></div>';
			},
			replaceCruiseDayEvent(event) {
				if (event.type === 'selected-image') {
					this.selectedDay.image = event.image;

					if (event.video) {
						this.selectedDay.video = event.video;
					}
				}

				if (event.type === 'close-modal') {
					this.closeReplaceModal();
				}
			},
			replaceImage(cruiseDay) {
				this.selectedDay      = cruiseDay;
				this.showReplaceModal = true;
			},
			async replaceImageOld(cruiseDay) {
				const modal   = new bootstrap.Modal('#modalWindow');
				const modalEl = $('#modalWindow');

				modalEl.addClass('wide');
				modalEl.find('.modal-title').text('Replace cruise day image');
				modalEl.find('.modal-body').text('Loading details...');

				modal.show();
				modalEl.on('hidden.bs.modal', function _restoreModal() {
					modalEl.removeClass('wide').off('hidden.bs.modal');
					modalEl.find('.modal-body').html();
				});

				try {
					const html = await Adzuki.Ajax.get('/TripSummaryPictureLibrary/cruiseDayImage');

					modalEl.find('.modal-body').html(html);

					this.initUploadImageForm(cruiseDay, modal);
					this.initAddImageFromLibraryForm(cruiseDay, modal);
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error adding new image: ${error.message}`);
				}
			},
			async setCruiseDayImageFromLibrary(cruiseDay, imageId) {
				try {
					const url      = '/TripSummaryPictureLibrary/getImagePath/' + imageId;
					const response = await Adzuki.Ajax.get(url);

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error setting cruise day image: ${response.error}`);
					}

					cruiseDay.image = response.image_path + response.image;
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error setting the cruise day image: ${error.message}`);
				}
			},
		},
		mounted() {
			// nothing to do for now
		},
	};

	// this has been replaced with maxx media, keeping just in case
	// eslint-disable-next-line no-unused-vars
	function _initDragDropUpload() {
		Adzuki.DragDropUpload.start($('.cruise-day-image-upload .file-upload-options'));

		$(document).on('click', '.cruise-day-image-upload .file-upload-options .attachment-remove', function click(e) {
			const $self = $(this);

			e.stopPropagation();
			e.preventDefault();

			Adzuki.DragDropUpload.removeAttachment($self);
		});

		$(document).on('click', '.cruise-day-image-upload .file-upload-options .attachment-view', function click(e) {
			const $self  = $(this);
			let in_modal = false;

			e.stopPropagation();
			e.preventDefault();

			if ($self.parents('div.modal-body').length) {
				in_modal = true;
			}

			Adzuki.DragDropUpload.viewAttachment($self, in_modal);
		});
	}

	function _initLocationSearch() {
		Adzuki.Typeahead(
			'#cruisedayimage-location_term',
			'/Searches/googleAutocomplete/',
			async function select(item) {
				try {
					const response = await Adzuki.Ajax.get('/Searches/googlePlace/' + item.id);

					$('.pictures').html(response);
					$('#cruisedayimage-location_term').prop('disabled', true);
					$('.reset-day-location-search').removeClass('d-none');
				} catch (e) {
					Adzuki.StatusMessage('error', `Error searching for location: ${e.message}`);
				}
			},
			function template(item) {
				return item.name;
			}
		);

		$('.pictures').on('click', '.google-image', function _selectPicture() {
			const src  = $(this).data('src');
			const $obj = $(this);
			
			$('.google-image').removeClass('google-image-active');

			$obj.addClass('google-image-active');

			$('#cruisedayimage-image_url').val(src);
		});

		$('.reset-day-location-search').on('click', function _clearLocation(e) {
			e.preventDefault();

			$('#cruisedayimage-location_term').val('');
			$('#cruisedayimage-location_term').prop('disabled', false);
			$('.reset-day-location-search').addClass('d-none');
			$('.pictures').html('');
		});
	}

	Adzuki.VueComponents.TripSummaryCruiseDays = component;
}(jQuery, window.Adzuki || {}));
